import Swal from "sweetalert2";

/**
 * Ask whether a STEP/3D refresh should be "simple" or "hard".
 *
 * @param {Object} args
 * @param {string} args.title Heading for the prompt.
 * @param {string} args.text Body copy — say what is being refreshed and how much of it.
 * @returns {Promise<"hard"|"simple"|null>} null when the user backs out.
 *
 * Shared by the Equipment table's three sync actions and the Pipeline Monitor's reset so
 * the two options are worded and coloured identically everywhere. The distinction is not
 * self-evident from the button labels alone, and having one screen call it "hard refresh"
 * and another "force rebuild" is how users learn to avoid whichever one they don't
 * recognise.
 *
 * Simple is the CONFIRM button and hard is the DENY button, which reads backwards until
 * you look at the colours: SweetAlert paints deny red, and hard refresh is the
 * destructive-ish one — it rebuilds models the server would otherwise leave alone and
 * sends every machine to the converter. Putting it on the safe-looking primary button is
 * how a whole site accidentally gets re-converted.
 */
export const askRefreshMode = async ({ title, text }) => {
	const choice = await Swal.fire({
		icon: "question",
		title,
		text,
		showDenyButton: true,
		showCancelButton: true,
		confirmButtonColor: "#3085d6",
		denyButtonColor: "#d33",
		cancelButtonColor: "#6c757d",
		confirmButtonText: "Simple refresh",
		denyButtonText: "Hard refresh",
		cancelButtonText: "Cancel",
	});
	if (choice.isConfirmed) return "simple";
	if (choice.isDenied) return "hard";
	return null;
};
